module.exports = __webpack_public_path__ + "files/7d31ef39814b4fc3164260e46f1fa460.png";